import { useState, useEffect } from 'react'
import { Landlord, ListingLandlords } from '../types'
import { findPrimaryLandlord, findSecondaryLandlords } from '../util/landlords'

export const useLandlordValues = (landlordData: ListingLandlords) => {
  const [primaryLandlord, setPrimaryLandlord] = useState<Landlord[]>([])
  const [secondaryLandlords, setSecondaryLandlords] = useState<Landlord[]>([])

  useEffect(() => {
    if (!landlordData) return
    setPrimaryLandlord(findPrimaryLandlord(landlordData?.listing_landlords))
    setSecondaryLandlords(findSecondaryLandlords(landlordData?.listing_landlords))
  }, [landlordData])

  return {
    primaryLandlord,
    setPrimaryLandlord,
    secondaryLandlords,
    setSecondaryLandlords
  }
}
